import { IAssessmentCard } from "../pages/assessment/StepTwo";

const infoSvg = require("../assets/images/svg/info-icon.svg").default;

export interface IAssessmentCardProps {
  card: IAssessmentCard;
  handleCardClick: (id: number) => void;
}
const AssessmentCard = ({ card, handleCardClick }: IAssessmentCardProps) => {
  return (
    <div
      onClick={() => {
        if (!card?.isDisabled) {
          handleCardClick(card.id);
        }
      }}
      className={`${card?.isDisabled ? "disabled-card" : "enabled-mouse"} ${
        card?.title ? "recommended-card" : "card-main"
      } ${card.recommended ? "highlighted" : ""}`}
    >
      {card.title && <p className="card-title">{card.title}</p>}
      <div
        className={`card-inner justify-content-start`}
      >
        <img src={infoSvg} className="info-icon" alt="Info icon" />
        <img
          src={card.assessmentImage}
          className={card.imageClass}
          alt="Info icon"
        />
        {card.date ? (
          <button className="button-dark-outline">
            {card.buttonText}
            <span>
              {card.date} <br /> {card.time}
            </span>
          </button>
        ) : (
          <button
            className={`${card?.isDisabled ? "disabled-card" : "enabled-mouse"} ${
              card.outlineButton ? "outlined-button" : "button-dark"
            }`}
            disabled={card?.isDisabled}
          >
            {card.buttonText}
          </button>
        )}
        <p className="card-description">{card.description}</p>
      </div>
    </div>
  );
};

export default AssessmentCard;
